// components/chat/SessionNotesModal.jsx
import React, { useState, useEffect } from "react";
import "./SessionNotesModal.css";

export default function SessionNotesModal({ inicial = "", onSave, onClose }) {
  const [nota, setNota] = useState(inicial);

  // Atualiza se mudar ao trocar de sessão
  useEffect(() => {
    setNota(inicial || "");
  }, [inicial]);

  return (
    <div className="notes-modal-backdrop">
      <div className="notes-modal">
        <h3>Notas internas</h3>

        <textarea
          value={nota}
          onChange={(e) => setNota(e.target.value)}
          placeholder="Digite observações internas sobre este atendimento..."
        />

        <div className="notes-modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancelar
          </button>

          <button
            className="btn-save"
            onClick={() => onSave(nota)}
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
}
